import { z } from '@harvestiq/zod';
import { getLgmQuoteAndPdfParamsSchema } from './get-lgm-quote-and-pdf-params-schema';
import { LgmCampaignPdfColumns } from '@harvestiq/constants';
import { lgmSingleHeadQuoteSchema } from '@harvestiq/usda-common/lgm-helpers/lgm-single-head-quote';

export const createLgmQuotePDFSchema = getLgmQuoteAndPdfParamsSchema
  .omit({
    targetSalesEffectiveDate: true,
  })
  .extend({
    salesEffectiveDate: z.string(),
    quotes: z.record(z.string(), lgmSingleHeadQuoteSchema.array()),
    quoteColumns: z.array(z.nativeEnum(LgmCampaignPdfColumns)).optional(),
    logoUrl: z.string().url(),
    orgId: z.string(),
    campaignId: z.string().optional(),
  });
export type CreateLgmQuotePDFParams = z.infer<typeof createLgmQuotePDFSchema>;
